export default __webpack_public_path__ + "static/media/dv360-icon.8db26c55.png";